import {Modal, Steps} from 'antd';
import React, {useState} from 'react';

import {ConfirmationModal} from '../';
import {UserValidateStep} from '../userValidateStep/userValidateStep';
import './userValidateModal.css';

const {Step} = Steps;

const stepsCode = {
  default: 0,
  created: 0,
  in_progress: 1,
  requests_code: 1,
  done: 2,
  failed: 2,
};

export const UserValidateModal = ({
  visible,
  handleCancel,
  validateUser,
  validationInfo,
  userEmail,
  client,
  url,
}: any) => {
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const noValidation = !validationInfo?.id;
  const currentStepIndex = stepsCode[validationInfo?.status] || stepsCode.default;

  const onOk = () => {
    setConfirmationVisible(false);
    setTimeout(() => {
      handleCancel();
    }, 0);
  };

  const closeModal = () => {
    if (!['done', 'error'].includes(validationInfo.status)) {
      setConfirmationVisible(true);
      return;
    }
    handleCancel();
  };

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      maskClosable={false}
      footer={null}
      width={800}
      title={`Validation process ${userEmail ? `for ${userEmail}` : ''}`}
      className="validate-user-modal"
    >
      <ConfirmationModal visible={confirmationVisible} onOk={onOk} onCancel={() => setConfirmationVisible(false)} />
      {noValidation ? (
        <span>Loading...</span>
      ) : (
        <div>
          <Steps size="small" current={currentStepIndex}>
            <Step title="Starting" />
            <Step title="Requesting Code" />
            <Step title="Finished" />
          </Steps>
          <UserValidateStep
            userEmail={userEmail}
            validateUser={validateUser}
            validationInfo={validationInfo}
            client={client}
            url={url}
          />
        </div>
      )}
    </Modal>
  );
};
